import logoTsSmall from "./logo/logo-ts-small.png"

export const LogoIcon = () => {

  return (
    <img src={logoTsSmall} alt="logo ts" style={{width: 30}} />
  );
};